export default "__VITE_ASSET__DJ40QfvY__"